import React, { useEffect } from 'react';
import Loader from './layout/Loader';
import { reportNewRelicError } from './observability/reportNewRelicError';

const ErrorFallback = ({ error }) => {
  useEffect(() => {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (error?.message && chunkFailedMessage.test(error.message)) {
      if (localStorage.getItem('counter') === '1') {
        localStorage.removeItem('counter');
        return;
      }
      localStorage.setItem('counter', '1');
      window.location.reload();
      return;
    }
    reportNewRelicError(error, { route: window.location.pathname });
  }, [error]);

  return <Loader />;
};

export default ErrorFallback;
